var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9839",
    "data-name": "Group 9839",
    transform: "translate(-710 -538)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1714",
    "data-name": "Ellipse 1714",
    cx: 44,
    cy: 44.5,
    rx: 44,
    ry: 44.5,
    transform: "translate(710 538)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9810",
    "data-name": "Group 9810",
    transform: "translate(731.836 568.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plus-svgrepo-com_1_",
    "data-name": "plus-svgrepo-com (1)",
    d: "M12.313,5.776H6.537V0H5.776V5.776H0v.762H5.776v5.776h.762V6.537h5.776Z",
    transform: "translate(28.669 0)",
    fill: "#b7bbbc",
    stroke: "#b7bbbc",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "user-svgrepo-com_3_",
    "data-name": "user-svgrepo-com (3)",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9713",
    "data-name": "Group 9713",
    transform: "translate(0.57 0.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79926",
    "data-name": "Path 79926",
    d: "M18.757,276.978a12.79,12.79,0,0,1,25.581,0Z",
    transform: "translate(-18.757 -250.515)",
    fill: "#b7bbbc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1569",
    "data-name": "Ellipse 1569",
    cx: 6.837,
    cy: 6.837,
    r: 6.837,
    transform: "translate(5.954)",
    fill: "#b7bbbc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_79927",
    "data-name": "Path 79927",
    d: "M31,17.586a13.277,13.277,0,0,0-6.209-3.52,7.406,7.406,0,1,0-6.476,0A13.374,13.374,0,0,0,8.189,27.033a.57.57,0,0,0,.57.57H34.339a.57.57,0,0,0,.57-.57A13.272,13.272,0,0,0,31,17.586ZM15.282,7.406a6.267,6.267,0,1,1,6.267,6.267A6.274,6.274,0,0,1,15.282,7.406ZM9.342,26.464a12.221,12.221,0,0,1,24.415,0Z",
    transform: "translate(-8.189)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79928",
    "data-name": "Path 79928",
    d: "M55.39,330.2a.57.57,0,0,1-.554-.7,11.206,11.206,0,0,1,5.126-6.957.57.57,0,0,1,.584.978,10.06,10.06,0,0,0-4.6,6.245A.57.57,0,0,1,55.39,330.2Z",
    transform: "translate(-52.306 -305.071)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79929",
    "data-name": "Path 79929",
    d: "M200.559,296.26a.57.57,0,0,1-.131-1.124,11.192,11.192,0,0,1,2.581-.3.57.57,0,0,1,0,1.139,10.049,10.049,0,0,0-2.318.27A.572.572,0,0,1,200.559,296.26Z",
    transform: "translate(-189.649 -278.94)",
    fill: "#8c8c8c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.fabc692d685662698b376d1589c0bd58.svg";
export { ForwardRef as ReactComponent };